import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { WithdrawalProgress } from '@/components/features/withdrawals/WithdrawalProgress';
import { TransactionDetails } from '@/components/features/transactions/TransactionDetails';
import { useWithdrawalStatus } from '@/lib/hooks';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { ROUTES } from '@/config/routes';
import {WithdrawalTransaction} from "@/lib/types";

export const Route = createFileRoute('/_auth/withdrawals/$id')({
  component: WithdrawalDetailComponent,
});

function WithdrawalDetailComponent() {
  const { id } = Route.useParams();
  const { data, isLoading, isError, error } = useWithdrawalStatus(Number(id), true);

  const breadcrumbs = [
    { label: 'Withdrawals', href: ROUTES.WITHDRAWALS },
    { label: `#${id}` },
  ];

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState title={error.name} message={error.message} />;
  }

  return (
    <div className="space-y-6">
      <Breadcrumbs items={breadcrumbs} />
      
      <PageHeader
        title="Withdrawal Details"
        description={`Withdrawal #${id}`}
      />

      <WithdrawalProgress withdrawal={data! as WithdrawalTransaction} />

      <TransactionDetails transaction={data!} />
    </div>
  );
}
